import OptionHOC from '@platform/react/hoc/autocomplete/option'
import { Badge, Grid, useTheme } from '@mui/material'
import { getFirstItem } from 'lib/util'
import Text from 'ui/Element/Text'
import { useContext } from 'react'
import ApplicationContext from 'platform/react/context/application'
import Icon from 'ui/Element/Icon'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  option: {
    gap: '0.75rem',
  },
  subLabel: {
    gap: '0.25rem',
  },
  icon: {
    width: '3rem',
    height: '3rem',
  },
})

/**
 * Displays the name of an organisation alongside a sub-label consisting of a concatenated string
 * of organisation type, city and number.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
const RequestOption = (classes, props = {}) => {
  const theme = useTheme()
  const { intl } = useContext(ApplicationContext)
  const { option, labels, events } = props
  const { created: createdLabel = null } = labels

  const {
    value: {
      status,
      number,
      type: typeKey,
      submit: { timestamp } = {},
      unreadMessages = 0,
    } = {},
  } = option

  const [type] = events?.getTicketType?.(typeKey) || []
  const typeIcon = type?.icon

  const { color = 'black.main', backgroundColor = 'background.mobile' } = getFirstItem(events?.getRequestStatus?.(status)) || {}
  const subLabel = getSubLabel(Text, [createdLabel, intl.getLocaleDate(timestamp)])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.option}
    >
      <Grid
        item
        ms={'auto'}
        className={classes.icon}
      >
        <Badge
          color={'signal'} // background-color
          overlap={'circular'}
          badgeContent={unreadMessages}
          sx={{ color: theme.palette.white.main }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Icon
            color={color}
            shape={'circle'}
            size={'1.5rem'}
            source={typeIcon}
            background={backgroundColor}
          />
        </Badge>
      </Grid>
      <Grid
        item
        ms={'auto'}
      >
        <Grid
          container
          height={'100%'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={number}
            variant={'14/bold'}
            color={'black.main'}
          />
          {createdLabel && timestamp && (
            <Grid
              item
              container
              ms={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(RequestOption, styles)
